


























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { statisticDetailTimes } from '@/constants/type-helper';
import { namespace } from 'vuex-class';
import { AcgnFormTitle } from '@/components';
import { AcgnTable, AcgnPermission } from '@acgn/herm/src/ui';
import { openUrl } from '@/util';
import AcgnPopFiledHistory from '../pop-field-history.vue';

const StatisticNorAction = namespace('desk/statisticNor').Action;
const StatisticAction = namespace('desk/statistic').Action;
import { DataTypesMixin } from '@/mixins';

@Component({
  components: {
    AcgnTable,
    AcgnFormTitle,
    AcgnPermission,
    AcgnPopFiledHistory
  },
  mixins: [ DataTypesMixin ]
})

/**
 * 逾期情况-创作方
 */
export default class AcgnOverdueNorDetail extends Vue {

  @Prop({ default: null }) public comicId: number | null; // 项目id
  @Prop({ default: null }) public userId: number | null; // 成员id
  @Prop({ default: '' }) public exportCode: string; // 导出权限码
  // 1：创作方统计，2：管理方统计
  @Prop({ default: 1 }) public type: number; // 用于区分请求数据接口

  // 1：创作方-逾期明细 2：管理方-逾期明细
  @Prop({ default: 1 }) public routeType: number; // 用于区分数字点击跳转明细页面

  @StatisticNorAction private getOverdueCycleDetail: any;
  @StatisticAction private getOverdueCycleAdminDetail: any;

  private selectOpts: any = statisticDetailTimes;
  private selectType: number = 2;

  // 1：管理方-总览 2：管理方-项目
  private detailRoute: any = {
    1: 'desk-statisticNorOverdueComicDetail',
    2: 'desk-statisticOverdueComicStaffDetail'
  };

  private apiKey: any = {
    1: 'getOverdueCycleDetail',
    2: 'getOverdueCycleAdminDetail'
  };

  private tableConfig: any = {
    columns: [
      {
        label: '项目',
        prop: 'time_slot',
        width: 200
      },
      {
        label: '逾期提交',
        prop: 'over_submit',
        render: (h: any, { row }: any) => (this as any).renderLink(row, 'over_submit')
      },
      {
        label: '逾期提交率',
        prop: 'over_submit_rate'
      }
    ],
    data: []
  };

  private pageConfig: any = {}; // 分页数据
  private dataType: number = (this as any).type === 2 ? 4 : 0;
  private options: any = {
    apiType: 2,
    userId: (this as any).userId,
    cycle_type: this.dataType > 0 ? 3 : this.selectType,
    project_id: (this as any).comicId
  };

  private renderLink(row: any, key: string) {
    const type = key === 'over_submit' ? 1 : 2;
    const routeName = this.detailRoute[this.routeType];

    const values = row[key];
    const numValue = values[0];
    const numDiff = values[1];

    const classStyle = numDiff ? 'color--danger' : '';
    const numShow = numDiff ? numValue + numDiff : numValue;
    if (this.comicId) {
      return (
        <acgn-permission class={classStyle} to={{ name: routeName, params: { id: this.comicId, type } }}>
          {numShow}
        </acgn-permission>
      );
    }
    return (
      <span class={classStyle}>{numShow}</span>
    );
  }

  // table组件获取数据更新数据接口
  private async initSearh() {
    const { tableConfig, pageConfig } = this;
    const options = this.getSearchOptions();
    const { result } = await (this as any)[this.apiKey[this.type]](options);
    tableConfig.data = result;
  }

  private getSearchOptions() {
    return {
      type: this.selectType,
      project_id: this.comicId,
      user_id: this.userId,
      order: this.dataType > 0 ? 1 : 2,
      data_type: this.dataType
    };
  }

  private selectChange() {
    this.options.cycle_type = this.dataType > 0 ? 3 : this.selectType; // 解决历史记录问题
    this.initSearh();
  }

  private exportExcel() {
    if (this.type === 1) {
      openUrl('/api/v1/workbench/overduecycle?export=1', this.getSearchOptions());
    } else {
      openUrl('/api/v1/workbench/getoverduecycleofadmin?export=1', this.getSearchOptions());
    }
  }
}
